import { render, staticRenderFns } from "./SonAccount.vue?vue&type=template&id=729f8739&scoped=true&"
import script from "./SonAccount.vue?vue&type=script&lang=js&"
export * from "./SonAccount.vue?vue&type=script&lang=js&"
import style0 from "./SonAccount.vue?vue&type=style&index=0&id=729f8739&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729f8739",
  null
  
)

export default component.exports